import store, { State, IProjectState } from 'store';
import { produce } from 'immer';

import getProjectState from 'store/getProjectState';

type GetUpdatedState = (projectState: IProjectState) => IProjectState;

export default function setProjectState(
  projectId: string,
  getUpdatedState: GetUpdatedState,
) {
  store.setState(
    produce((state: State) => {
      state.projectStateMap[projectId] = getUpdatedState(
        getProjectState(state, projectId),
      );
    }),
  );
}
